import { render, staticRenderFns } from "./PresenGift.vue?vue&type=template&id=4cf6b7cc"
import script from "./PresenGift.vue?vue&type=script&lang=js"
export * from "./PresenGift.vue?vue&type=script&lang=js"
import style0 from "./PresenGift.vue?vue&type=style&index=0&id=4cf6b7cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports